import React, { forwardRef, useImperativeHandle, useState } from 'react';
import dynamic from 'next/dynamic';
import styled from '@emotion/styled';
import { Flex } from '$components/layouts';
import { IProduct } from '$models';
import { useTranslation } from '$hooks';
import { Modal } from '$components/elements/modal';
import { ModalRef } from '../product-page';
import { Loading } from '$components/elements/loading';

export const ProductReviewModal = dynamic(() => import('./components/user-review-modal'), {
    ssr: false,
    loading: () => (
        <ReviewModalLoader justifyContent="center" alignItems="center">
            <Loading />
        </ReviewModalLoader>
    ),
});

type ProductReviewsProps = {
    product?: IProduct;
};

export const ProductAddReview = forwardRef<ModalRef, ProductReviewsProps>((props: ProductReviewsProps, ref) => {
    const { product } = props;
    const { translate } = useTranslation();
    const [isWriteReviewOpen, setIsWriteReviewOpen] = useState(false);

    useImperativeHandle(ref, () => ({
        open() {
            setIsWriteReviewOpen?.(true);
        },
        close() {
            setIsWriteReviewOpen?.(false);
        },
    }));

    return (
        <>
            <Modal
                title={translate('productPage.productReviews.writeUserReview')}
                show={isWriteReviewOpen}
                onDismiss={() => setIsWriteReviewOpen(false)}
            >
                {!!product && <ProductReviewModal product={product} closeModal={() => setIsWriteReviewOpen(false)} />}
            </Modal>
        </>
    );
});

const ReviewModalLoader = styled(Flex)({
    minWidth: '330px',
    minHeight: '280px',
});
